module.exports = "https://web-assets.ifttt.com/packs/media/docs/publish_connected_features-93b73840.png";